import {notifyForError} from 'dev/service-worker-components/errors';
import {MessageType, sendToServiceWorker} from 'dev/service-worker-interop/Message';

export default function doServiceWorkerFastRefresh(): void {
  const sw = global.__activeDevServiceWorker;
  if (!sw) {
    notifyForError('Fast refresh failed! Could not connect to dev service worker.');
    return;
  }
  sendToServiceWorker(sw, {
    messageType: MessageType.INITIATE_FAST_REFRESH,
  });
}
